import { Download, Scissors } from "lucide-react";
import { Button } from "@/components/ui/button";
import { API_URL } from "@/api/client";

/**
 * Pomocník pre Cut Rite (KOLO 141) — zip s inštalátorom na stiahnutie.
 *
 * User k inštalácii: *„takže ako mám nainštalovať to"*. Ručný postup
 * (súbory z GitHubu, JSON, PowerShell, Plánovač úloh) bol na dielenské PC
 * priveľa — teraz stačí zip rozbaliť a dvojklikom spustiť `instaluj.bat`.
 * Kľúč v zipe nie je (server má len jeho odtlačok), inštalátor sa naň
 * opýta — preto sekcia stojí hneď pod „Môj kľúč pre Tandem Zostavy".
 *
 * Obyčajný odkaz, nie fetch: zip ide za prihlásením cez session cookie
 * a prehliadač ho uloží sám.
 */
export const POMOCNIK_ZIP = `${API_URL}/cutrite/pomocnik.zip`;

export function CutritePomocnikSection(): JSX.Element {
  return (
    <section
      className="space-y-3 rounded-lg border bg-card p-4"
      aria-labelledby="cutrite-pomocnik-nadpis"
    >
      <div>
        <h2 id="cutrite-pomocnik-nadpis" className="flex items-center gap-2 text-xl">
          <Scissors className="h-5 w-5 text-primary" />
          Pomocník pre Cut Rite
        </h2>
        <p className="text-xs text-muted-foreground">
          Beží na PC s Cut Rite a do 15 sekúnd naimportuje, čo pošleš cez{" "}
          <strong>Výstupy → Poslať do Cut Rite</strong>. Importnú šablónu
          „rozpocty" si pred každým importom nastaví sám.
        </p>
      </div>

      <ol className="list-decimal space-y-1 pl-5 text-sm">
        <li>Stiahni pomocníka a zip prenes na PC s Cut Rite.</li>
        <li>
          Rozbaľ ho (pravý klik → <strong>Extrahovať všetko</strong>) a dvojklikom
          spusti <span className="font-mono">instaluj.bat</span> — pod
          používateľom Windows, ktorý v Cut Rite pracuje.
        </li>
        <li>
          Keď sa opýta na kľúč, vlož ten zhora (Môj kľúč pre Tandem Zostavy).
          Na konci ukáže výsledok testu spojenia.
        </li>
      </ol>
      <p className="text-xs text-muted-foreground">
        Novú verziu nainštaluješ rovnako — doterajší kľúč aj nastavenia
        ostanú.
      </p>

      <Button asChild size="sm">
        <a href={POMOCNIK_ZIP} download>
          <Download className="h-4 w-4" />
          Stiahnuť pomocníka
        </a>
      </Button>
    </section>
  );
}
